import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';

const {
  confirmUserEmailSaga
} = actions;

class ConfirmEmail extends Component {
  constructor(props) {
    super(props);
    this.token = props.location && props.location.query && props.location.query.token;
  }

  componentDidMount = () => {
    this.props.confirmUserEmail(this.token)
  }

  render() {
    return (
      <main className="site--width">
        <h6>
          Verifying token
        </h6>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    confirmUserEmail: (token) => dispatch(confirmUserEmailSaga(token))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);



/** WEBPACK FOOTER **
 ** ./src/containers/ConfirmEmail/ConfirmEmail.jsx
 **/